export interface DashboardEditState {
  id: string;
  title: string;
  url: string;
  category: string;
  school_year: string;
}

export interface DashboardOriginal {
  id: string;
  title: string;
  url: string;
  category: string;
  school_year: string;
}

/**
 * Compute the minimal set of changed fields between edit state and original dashboard.
 * Returns null if nothing changed or title is whitespace-only.
 */
export function computeEditChanges(
  edit: DashboardEditState,
  original: DashboardOriginal,
): { id: string; title?: string; url?: string; category?: string; school_year?: string } | null {
  const changes: {
    id: string;
    title?: string;
    url?: string;
    category?: string;
    school_year?: string;
  } = {
    id: edit.id,
  };

  if (edit.title.trim() && edit.title !== original.title) changes.title = edit.title.trim();
  if (edit.url.trim() && edit.url !== original.url) changes.url = edit.url.trim();
  if (edit.category !== original.category) changes.category = edit.category;
  if (edit.school_year !== original.school_year) changes.school_year = edit.school_year;

  if (!changes.title && !changes.url && !changes.category && !changes.school_year) return null;
  return changes;
}

/**
 * Add a new item to a sorted list. Trims whitespace, rejects empty/duplicate, sorts alphabetically.
 * Returns the new sorted list, or null if the item was rejected.
 */
export function addToSortedList(items: string[], newItem: string): string[] | null {
  const trimmed = newItem.trim();
  if (!trimmed || items.includes(trimmed)) return null;
  return [...items, trimmed].sort((a, b) => a.localeCompare(b));
}

/**
 * Sort dashboards for the admin management list: archived last, then alphabetical by title.
 */
export function sortDashboardsForAdmin<T extends { title: string; archived: boolean }>(
  dashboards: T[],
): T[] {
  return [...dashboards].sort((a, b) => {
    if (a.archived !== b.archived) return a.archived ? 1 : -1;
    return a.title.localeCompare(b.title);
  });
}
